import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from './services/theme.service';
import { RoutePartsService } from './services/route-parts.service';
import { AppConfirmService } from './services/app-confirm/app-confirm.service';
import { AppLoaderService } from './services/app-loader/app-loader.service';
import { SharedComponentsModule } from './components/shared-components.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { SharedDirectivesModule } from './directives/shared-directives.module';
import { AppComfirmLogoutComponent } from './services/app-confirm/app-confirm-logout.component';
import { UserScopeService } from './services/user-scope.service';
import { BrowserCasbinService } from './services/casbin/browser-casbin.service';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    SharedPipesModule,
    SharedDirectivesModule,
  ],
  providers: [
    ThemeService,
    RoutePartsService,
    AppConfirmService,
    AppLoaderService,
    AppComfirmLogoutComponent,
    BrowserCasbinService,
    UserScopeService,
  ],
  exports: [SharedComponentsModule, SharedPipesModule, SharedDirectivesModule],
})
export class SharedModule {}
